import styled from 'styled-components';
import {
  background,
  border,
  color,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system';

export const StyledTextArea = styled.textarea`
  outline: none;

  ${color}
  ${border}
  ${typography}
  ${layout}
  ${space}
  ${shadow}
  ${background}
  ${position}
`;
